import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WHEnumPipe } from './wh-enum.pipe';
import { CustomTranslatePipePipe } from './custom-translate-pipe.pipe';
import { DayOfWeekPipe } from './dayofweek.pipe';
import { DurationPipe } from './duration.pipe';
import { ParamsTranslatePipe } from './params-translate.pipe';
import { TruncatePipe } from './truncate.pipe';
import { RemovePrefixPipe } from './q_remove.pipe';
import { MimeTypeIconPipe } from './mimeTypeIcon.pipe';
import { ShortenUrlPipe } from './link-shortener.pipe';
import { HighlightPipe } from './highlight.pipe';
import { SplitAndTranslatePipe } from './split-and-translate.pipe';
import { EnumLabelPipe } from './enum-label.pipe';
import { FindByIdPipe } from './find-by-id.pipe';
import { StatusColorPipe } from './status-color.pipe';

@NgModule({
  declarations: [
    WHEnumPipe,
    SplitAndTranslatePipe,
    CustomTranslatePipePipe,
    DayOfWeekPipe,
    DurationPipe,
    ParamsTranslatePipe,
    TruncatePipe,
    RemovePrefixPipe,
    MimeTypeIconPipe,
    ShortenUrlPipe,
    HighlightPipe,
    EnumLabelPipe,
    FindByIdPipe,
  ],
  imports: [CommonModule, StatusColorPipe],
  exports: [
    StatusColorPipe,
    WHEnumPipe,
    SplitAndTranslatePipe,
    CustomTranslatePipePipe,
    DayOfWeekPipe,
    DurationPipe,
    ParamsTranslatePipe,
    TruncatePipe,
    RemovePrefixPipe,
    MimeTypeIconPipe,
    ShortenUrlPipe,
    HighlightPipe,
    EnumLabelPipe,
    FindByIdPipe,
  ],
})
export class WHPipesModule {}
